import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Axios from 'axios';
import { AUTH_ROUTES } from 'routers/RouteConstants';
import { LOGIN_API, AUTH_VERIFY } from 'config/rest_endpoints';
import CustomLoader from 'components/common/loader';
import Logo from 'components/common/Logo';
import './style.css';

const Login = () => {
  const clearLocalStorageParam = new URLSearchParams(window.location.search).get(
    'clearLocalStorage'
  );
  const token = localStorage.getItem('verifyToken');
  const history = useHistory();

  const [userDetails, setUserDetails] = useState({ username: '', password: '' });
  const [isLogin, setIsLogin] = useState(false);
  const [isError, setIsError] = useState('');
  const [isVerify, setIsVerify] = useState(false);
  const [urlVal, setUrlVal] = useState('');
  const [isLoad, setIsLoad] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (clearLocalStorageParam === 'yes') {
      localStorage.removeItem('verifyToken');
      localStorage.removeItem('verifyTokenToSelectTenant');
      localStorage.removeItem('token');
    }
  }, [clearLocalStorageParam]);

  useEffect(() => {
    if (clearLocalStorageParam !== 'yes') {
      verifyTokenFuc();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const verifyTokenFuc = () => {
    const temp = token ? JSON.parse(token) : null;
    setIsLoad(true);

    if (!temp) {
      setIsLoad(false);
      return;
    }

    const headers = { Authorization: 'Bearer ' + temp };
    Axios.get(AUTH_VERIFY, { headers })
      .then(res => {
        if (res.status === 200) {
          const domain = res.data.response.data.user.tenant.domain;
          setIsVerify(true);
          setUrlVal(`${domain}?id=${temp}`);
        } else {
          localStorage.removeItem('verifyToken');
          localStorage.removeItem('verifyTokenToSelectTenant');
          localStorage.removeItem('token');
          localStorage.clear();
          setIsVerify(false);
        }
        setIsLoad(false);
      })
      .catch(() => {
        localStorage.removeItem('verifyToken');
        localStorage.removeItem('verifyTokenToSelectTenant');
        localStorage.removeItem('token');
        setIsVerify(false);
        setIsLoad(false);
        history.push(AUTH_ROUTES.login);
      });
  };

  const handleValue = e => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const onLogin = e => {
    e.preventDefault();
    setIsLogin(true);

    const body = {
      email: userDetails.username,
      password: userDetails.password,
    };

    const header = { headers: { 'Content-Type': 'application/json' } };
    Axios.post(LOGIN_API, body, header)
      .then(res => {
        if (res.status === 200) {
          localStorage.setItem('token', JSON.stringify(res.data.response.data.token));
          history.push(AUTH_ROUTES.otpPage, { state: res.data.response });
        }
      })
      .catch(err => {
        if (err.response && err.response.status === 451) {
          setErrorMessage(
            'This app is not available in your region. If you think you are seeing this in error, please contact our support team'
          );
        } else {
          setErrorMessage(
            String(err.response?.data?.response?.error || 'Login failed')
              .charAt(0)
              .toUpperCase() +
              String(err.response?.data?.response?.error || 'Login failed').slice(1)
          );
        }
        setIsError('failed');
        setIsLogin(false);
      });
  };

  const gotoApp = () => {
    setTimeout(() => {
      window.location = urlVal;
    }, 1000);
    return <CustomLoader />;
  };

  return isLoad ? (
    <CustomLoader />
  ) : isVerify ? (
    gotoApp()
  ) : (
    <section className="login-form-container">
      <article className="login-page">
        <picture className="site-logo">
          <Logo width={'450px'} height={'450px'} />
        </picture>
        <form className="login-form" onSubmit={onLogin} style={{ background: '#f1f1f1' }}>
          <div className="card login-card border-0" style={{ boxShadow: 'none' }}>
            <div className="card-body login-card-body">
              {isError === 'failed' && (
                <div
                  className="alert alert-danger alert-dismissible"
                  style={{ marginBottom: '0.25rem' }}
                >
                  <span className="font-weight-semibold">{errorMessage}</span>
                </div>
              )}

              <div className="form-group form-group-feedback form-group-feedback-left">
                <input
                  type="text"
                  className="form-control"
                  name="username"
                  value={userDetails.username}
                  onChange={handleValue}
                  placeholder="Email"
                  autoFocus
                  disabled={isLogin}
                />
                <div className="form-control-feedback">
                  <i className="icon-user text-muted"></i>
                </div>
              </div>
              <div className="form-group form-group-feedback form-group-feedback-left">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  name="password"
                  value={userDetails.password}
                  onChange={handleValue}
                  placeholder="Password"
                  disabled={isLogin}
                />
                <div
                  className="form-control-feedback"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <img
                    src={
                      showPassword
                        ? '/assets/svg-icons/bi-eye.svg'
                        : '/assets/svg-icons/bi-eye-slash.svg'
                    }
                    alt="toggle-password"
                    className="eye-icon"
                  />
                </div>
              </div>
              <div className="form-group text-right">
                <button
                  type="submit"
                  className="btn btn-theme-primary btn-lg"
                  disabled={isLogin}
                  style={{ background: '#17A6A8' }}
                >
                  Sign in {isLogin && <i className="icon-spinner2 spinner ml-2"></i>}
                </button>
              </div>
              <div className="form-group text-right">
                <Link to={AUTH_ROUTES.resetPassword}>Forgot password?</Link>
              </div>

              <article
                style={{
                  paddingTop: '10px',
                  position: 'absolute',
                  bottom: '-20px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '100%',
                }}
              >
                <h2 style={{ fontSize: '12px', textAlign: 'center', color: '#7c7c7c' }}>
                  HeliumApp uses IP2Location.io{' '}
                  <a
                    href="https://www.ip2location.io"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: '#17A6A8', fontWeight: 'bold' }}
                  >
                    IP geolocation
                  </a>{' '}
                  web service.
                </h2>
              </article>
            </div>
          </div>
        </form>
      </article>
    </section>
  );
};

export default Login;
